import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { FacilityProvider } from '../../providers/facility/facility';
// import { Downloader, DownloadRequest, NotificationVisibility } from '@ionic-native/downloader/ngx';
import { ToastProvider } from '../../providers/toast/toast';
import { Storage } from '@ionic/storage';
import { convertDataToISO } from 'ionic-angular/umd/util/datetime-util';
import moment from 'moment';
import { SocialSharing } from '@ionic-native/social-sharing';
import { environment } from '../../environments/environment';



/**
 * Generated class for the TemplateDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-template-details',
  templateUrl: 'template-details.html',
})
export class TemplateDetailsPage {

  data: any
  type: any
  loginDetails = {}
  template_details: any
  showData = false
  URL_ISM = environment.ismUrl;

  constructor(public navCtrl: NavController,
    // private downloader: Downloader,
    private toast: ToastProvider,
    private storage: Storage,
    private socialSharing: SocialSharing,
    private facilityProvider: FacilityProvider,
    public navParams: NavParams) {

    this.storage.get("loginDetails").then(val => {

      console.log(val, "details")
      this.loginDetails['society_name'] = val.society_name;
      this.loginDetails['societyId'] = val.societyId;
      this.loginDetails['id'] = val.id;

      this.getTemplate(this.loginDetails['societyId'], this.type)
      console.log(val)
    })
    this.data = this.navParams.get("data");
    this.type = this.navParams.get("type");


  }


  getTemplate(id, type) {
    this.showData = false
    // this.template_details = {body:''}
    // this.template_details.body  = `<div id="printData">

    // <div class="head__section">
    //   <h2 class="text__center">{{loginDetails.society_name}} </h2>
    //   <p class="text__center">{{data.location.name}} </p>
    // </div>


    //  <div class="middle__section">

    //   <div class="main__icon__parking">  <i class="my__icon icon icon-md ion-md-car" ios="ios-car" md="md-car"></i> </div>
    //    <h2 class="text__center" *ngIf="data.data">  {{data.data.vehicle_no}} </h2>
    //    <p class="text__center">  <i ios="ios-time" md="md-time" class="icon icon-md ion-md-time"></i>  {{data.booking_from | customdate | date: "MMM d, h:m a"}} -  <b >{{data.booking_to | customdate | date: "MMM d, h:m a"}} </b></p>


    //     <h4 *ngIf="data.data"> <span > Name :</span> <span>{{data.data.name}}  </span> </h4>
    //     <h4 *ngIf="data.data"> <span > Phone No  :</span> <span> {{data.data.mobile_no}} </span> </h4>

    //   </div>
    //    <div class="fotter__section">
    //     <span class="text_center">This is a Parking Pass !</span>
    //    </div>
    // </div> 
    // `



    this.facilityProvider.getTemplate(id, type).then(val => {
      if (val.data && val.status == 'success' && val.data.length > 0) {
        this.showData = true
        this.template_details = val.data[0]
        this.template_details.body = this.template_details.body.replace('{{loginDetails.society_name}}', this.loginDetails['society_name'])
        this.template_details.body = this.template_details.body.replace('{{data.location.name}}', this.data.location.name ? this.data.location.name : '-')
        if (this.data.data) {
          this.template_details.body = this.template_details.body.replace('{{data.data.vehicle_no}}', this.data.data.vehicle_no ? this.data.data.vehicle_no : '-')
          this.template_details.body = this.template_details.body.replace('{{data.data.name}}', this.data.data.name ? this.data.data.name : '-')
          this.template_details.body = this.template_details.body.replace('{{data.data.mobile_no}}', this.data.data.phone_no ? this.data.data.phone_no : '-')
        }
        this.template_details.body = this.template_details.body.replace('{{data.booking_from | customdate | date: "MMM d, h:m a"}}', moment(this.data.booking_from).format('"MMM Do, hh:mm a"'))
        if (this.compareDate(this.data.booking_from, this.data.booking_to)) {
          this.template_details.body = this.template_details.body.replace('{{data.booking_to | customdate | date: "MMM d, h:m a"}}', moment(this.data.booking_to).format('hh:mm a'))
        } else {
          this.template_details.body = this.template_details.body.replace('{{data.booking_to | customdate | date: "MMM d, h:m a"}}', moment(this.data.booking_to).format('"MMM Do, hh:mm a"'))
        }

      } else {
        this.showData = true
        // this.getTemplate(0, this.type)
        this.template_details = {
          body:
          `
            <h3>${this.loginDetails['society_name']}</h3>
            <br>
            <h5>${this.data.location.name}</h5>
            <br>
          `
        }
        if (this.data.data) {
           this.template_details.body+= `<b>Vehicle no</b>  ${this.data.data.vehicle_no?this.data.data.vehicle_no:'-'}<br>`
           this.template_details.body+= `<b>Name</b>  ${this.data.data.name?this.data.data.name:'-' }<br>`
           this.template_details.body+= `<b>Phone no</b>  ${this.data.data.phone_no?this.data.data.phone_no:'-' }<br>`
        }
        this.template_details.body +=  `Timings ${moment(this.data.booking_from).format('MMM Do, hh:mm a')} To `
        if (this.compareDate(this.data.booking_from, this.data.booking_to)) {
          this.template_details.body +=  `${moment(this.data.booking_to).format('hh:mm a')}`
        } else {
          this.template_details.body +=  `${moment(this.data.booking_to).format('"MMM Do, hh:mm a"')}`
        }

      }
    })
  }

  // print(id, fun) {
  //   this.showData = false
  //   this.facilityProvider.print(id).then(val => {
  //     console.log(val)
  //     if (val) {
  //       if (fun == 'download') {
  //         this.download(val)
  //       }
  //       if (fun == 'share') {
  //         this.share(val)
  //       }

  //     } else {
  //       this.showData = true
  //       this.toast.presentToast("Something Went Wrong! Please try Again !");
  //     }

  //   });
  // }

  share(url) {
    console.log(url)
    this.showData = true

    // socialSharing
    var msg = `_Your Parking Details_ \n\nSociety Name - ${this.loginDetails['society_name']}   \n\n*${this.data.location.name ? this.data.location.name : '-'}* is your Parking Name  \n\n*${this.data.data.vehicle_no ? this.data.data.vehicle_no : '-'}* is your Vehicle Number . \n\n*${moment(this.data.booking_from).format('"MMM Do, hh:mm a"')} - ${moment(this.data.booking_to).format('"MMM Do, hh:mm a"')}*  is your Parking  Time . \n\n*${this.data.data.name ? this.data.data.name : '-'} (${this.data.data.phone_no ? this.data.data.phone_no : '-'})*  is your Details.  \n\nClick to below link: \n\n${this.URL_ISM}/my/parking/receipt/${this.loginDetails['societyId']}/${this.loginDetails['id']}/${this.data.id}/1  \n\n _iSocietymanager_                 
    ` 

    // http://localhost/isocietymanager/api/my/parking/receipt/2/200181/93/1


    console.log(msg)

    this.socialSharing.share(msg, null, null, null).then(() => {
      console.log("sharing done");
    }).catch(() => {
      this.toast.presentToast("Unable to share!");
    });
  }

  // download(url) {
  //   this.showData = true
  //   var downloadUrl = url

  //   var request: DownloadRequest = {
  //     uri: downloadUrl,
  //     title: "Parking Pass",
  //     description: 'Parking Pass for show when park the Vehicle !',
  //     mimeType: "image/png",
  //     visibleInDownloadsUi: true,
  //     notificationVisibility: NotificationVisibility.VisibleNotifyCompleted,
  //     destinationInExternalFilesDir: {
  //       dirType: 'Downloads',
  //       subPath: 'MyParkingPass.png'
  //     }
  //   };
  //   this.downloader.download(request).then((location: string) => {
  //     alert("File Downloaded at :" + location)
  //   }), (err) => {
  //     alert(JSON.stringify(err));
  //   }

  // }

  compareDate(fromDate, toDate) {
    var fd = new Date(fromDate).getDate();
    var td = new Date(toDate).getDate();
    if (fd == td) {
      return true;
    } else {
      return false;
    }
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad TemplateDetailsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/template-details/template-details.ts